import TanyaHowTo1Image from "public/assets/tanya/how-to-1.png";
import TanyaHowTo2Image from "public/assets/tanya/how-to-2.png";
import TanyaHowTo3Image from "public/assets/tanya/how-to-3.png";
import { ITanyaHowToData } from "./tanya-how-to.types";

export const tanyaHowToData: ITanyaHowToData = {
  1: {
    heading: "Siapin soal Matematika, Fisika atau Kimia",
    desc: "Untuk mulai, siapkan soal yang ingin kamu dapatkan jawabannya.",
    image: TanyaHowTo1Image,
    altText: "Siapin soal Matematika, Fisika atau Kimia"
  },
  2: {
    heading: "Ketik soalnya di kolom pencarian",
    desc: "Ketiknya yang detail ya biar gampang ketemu soalnya.",
    image: TanyaHowTo2Image,
    altText: "Ketik soalnya di kolom pencarian"
  },
  3: {
    heading: "Tonton video pembahasannya!",
    desc: "Ta-da! Dengerin penjelasan konsep dan ikuti langkah-langkah pengerjaannya. Selesai, deh!",
    image: TanyaHowTo3Image,
    altText: "Tonton video pembahasannya!"
  }
};
